<template>
    <!-- :position="isSmallerScreen ? 'top' : 'left'" -->
  <div class="help-mobile h-full">
    <vs-tabs
      :position="'top'"
      class="tabs-shadow-none menu-mob help-all"
      id="help-tabs"
      :key="isSmallerScreen"
      v-model="tabIndex"
    >
      <!-- GENERAL -->
    
    <!-- <vs-tab icon-pack="feather" icon="icon-lock" :label="!isSmallerScreen ? 'Dúvidas e Sugestões' : ''">
      <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
        <HelpSuggestions />
      </div>
    </vs-tab>-->
    <vs-tab icon-pack="feather" icon="icon-phone" :label="attendanceLabel" class="icon-help-all">
        <HelpAttendance :attendanceText="attendanceText" />
    </vs-tab>
    <!-- <vs-tab icon-pack="feather" icon="icon-github" :label="!isSmallerScreen ? 'Suporte' : ''">
      <div class="tab-social-links md:ml-4 md:mt-0 mt-4 ml-0">
        <HelpSupport />
      </div>
    </vs-tab>-->
    <vs-tab icon-pack="feather" icon="icon-info" :label="versionLabel" class="icon-help-all">
        <HelpVersion />
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-globe" :label="aboutLabel" class="icon-help-all">
        <HelpAbout />
    </vs-tab>
    <!-- <vs-tab icon-pack="feather" icon="icon-shield" label="LGPD">
      <div class="tab-info md:ml-4 md:mt-0 mt-4 ml-0">
        <HelpLGPD />
      </div>
    </vs-tab> -->
    <vs-tab icon-pack="feather" icon="icon-shield" :label="privacyPolicyLabel">
         <privacy-policy></privacy-policy>
     </vs-tab> 
     <vs-tab icon-pack="feather" icon="icon-file-text" :label="TermsUseLabel">
            <terms-use :displayActionButton="false"></terms-use>
    </vs-tab> 
     <vs-tab icon-pack="feather" icon="icon-settings" :label="quotesConfigLabel" v-if="isAuthenticated">
        <help-quotes-config></help-quotes-config>
    </vs-tab> 
    <!-- <vs-tab icon-pack="feather" icon="icon-info" :label="TourLabel">
      <div class="tab-info md:ml-4 md:mt-0 mt-4 ml-0">
        <vs-button
          class=""
          icon-pack="feather"
          icon="icon-play"
          type="border"
          @click="initTour">
          Ver novidades
      </vs-button>
      </div>
    </vs-tab> -->
    </vs-tabs>
    <div v-if="!isDesktop" class="v-nav-menu-swipe-area" v-hammer:swipe.right="onClose"></div>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import HelpAbout from "./HelpAbout.vue";
import HelpSupport from "./HelpSupport.vue";
import HelpAttendance from "./HelpAttendance.vue";
import HelpSuggestions from "./HelpSuggestions.vue";
import HelpVersion from "./HelpVersion.vue";
import HelpLGPD from "./HelpLGPD.vue";
import PrivacyPolicy from "./PrivacyPolicy.vue";
import AppConstants from '../../../appConstants';
import TermsUse from './TermsUse.vue';
import HelpQuotesConfig from './HelpQuotesConfig.vue';

export default {
  components: {
    HelpAbout,
    HelpSupport,
    HelpAttendance,
    HelpSuggestions,
    HelpVersion,
    HelpLGPD,
    PrivacyPolicy,
    VuePerfectScrollbar,
    TermsUse,
    HelpQuotesConfig,
  },
  props: {
    openAttendance: Boolean,
    attendanceText: String,
    openPrivacyPolicy: Boolean,
    openQuotesConfig: Boolean,
  },
  data() {
    return {
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.3
      },
      tabIndex: 2
    };
  },
  watch: {
    tabIndex(val) {
      // console.log('[tabIndex]', val)
      switch (val) {
        case 0:
          this.updateModalTitle(this.$t('HELP').Tab_Attendance);
          break;
        case 1:
          this.updateModalTitle(this.$t('HELP').Tab_Version);
          break;
        case 2:
          this.updateModalTitle(this.$t('HELP').Tab_About);
          break;
        case 3:
          this.updateModalTitle(this.$t('HELP').Tab_PrivacyPolicy);
          break;
        case 4:
          this.updateModalTitle(this.$t('HELP').Tab_Terms);
          break;
        case 5:
          this.updateModalTitle(this.$t('HELP').Tab_Quotes_Config);
          break;
        default:
          this.updateModalTitle('');
          break;
      }
    }
  },
  computed: {
    isAuthenticated() {
      return this.$store.state.isAuthenticated;
    },
    isSmallerScreen() {
      return this.$store.state.windowWidth < 1024;
    },
    aboutLabel() {
      return !this.isSmallerScreen ? this.$t('HELP').Tab_About : '';
    },
    attendanceLabel() {
      return !this.isSmallerScreen ? this.$t('HELP').Tab_Attendance: '';
    },
    versionLabel() {
      return !this.isSmallerScreen ? this.$t('HELP').Tab_Version: '';
    },
    privacyPolicyLabel() {
      return !this.isSmallerScreen ? this.$t('HELP').Tab_PrivacyPolicy: '';
    },
    TermsUseLabel() {
      return !this.isSmallerScreen ? this.$t('HELP').Tab_Terms: '';
    },
    TourLabel() {
      return !this.isSmallerScreen ? this.$t('HELP').Tab_Tour: '';
    },
    quotesConfigLabel() {
      return !this.isSmallerScreen ? this.$t('HELP').Tab_Quotes_Config: '';
    },
    isDesktop() {
      return this.$store.state.isDesktop;
    },
  },
  methods: {
    onClose() {
      this.$emit('close');
    },
    updateModalTitle(title) {
      this.$emit('update-modal-title', title);
    },
    initTour() {
      this.$tours['platformTour'].start();
      this.$emit('close');
    }
  },
  created() {
    if (this.openAttendance) {
      this.tabIndex = 0;
    }
    if (this.openPrivacyPolicy) {
      this.tabIndex = 3;
    }
    if (this.openQuotesConfig) {
      console.log('[openQuotesConfig]');
      this.tabIndex = 5;
    }
  },
  mounted() {
    // EventBus.$on(AppConstants.BUS_EVENT_OPENA_ATTENDANCE, () => {
    //   this.tabIndex = 1;
    // });
  },
  beforeDestroy() {
    // stop listening event
    // EventBus.$off(AppConstants.BUS_EVENT_OPENA_ATTENDANCE);
  }
};
</script>

<style lang="scss">
.con-vs-tabs .con-slot-tabs {
  width: 100%;
  height: 100%;
}
#help-tabs {
  .vs-tabs--content {
    padding: 0;
    height: 100%;
  }
  .tab-info {
    height: 100%;
  }
  .help-tab-scroll-content {
    position: relative;
    margin: auto;
    width: 100%;
  }
  .vs-tabs--ul {
    width: 100% !important;
    padding-bottom: 0px; 
  }
  .vs-tabs--li {
    width: 100% !important;
    // .icon-shield {
    //   margin-top: -13px;
    //   margin-right: -13px;
    //   padding-right: 5px !important;
    //   }
    }
}
</style>
